import { Accordion, WhyJoin, useText } from '@kkf/design'
import { WHY_JOIN } from '../data/services'
import { VOLUNTEER_FAQS } from '../data/faqs'
import { useT } from '../i18n'

/**
 * FAQ page.
 *
 * No styling of its own — it reuses the `ul-why-join` section with the same image, copy
 * and accordion as the Services page, so both render the one shared `WhyJoin` +
 * `Accordion` pair and differ only by wrapper variant.
 */
export function FaqPage() {
  const t = useT()
  const s = useText()
  return (
    <>
      {/* No banner and no breadcrumb (2026-09-21) — see `ContactPage` for the two things
          that travel with dropping one: the page's `<h1>`, which `Breadcrumb` used to
          carry, and `header.plainRoutes`, which nothing fails without. */}
      <section className="ul-plain-page-top">
        <div className="ul-container">
          <h1 className="ul-plain-page-title">{t('page.faqs')}</h1>
        </div>
      </section>

      <WhyJoin
        {...WHY_JOIN}
        subTitle={s(WHY_JOIN.subTitle)}
        title={s(WHY_JOIN.title)}
        descr={s(WHY_JOIN.descr)}
      >
        <Accordion items={VOLUNTEER_FAQS} />
      </WhyJoin>
    </>
  )
}
